import { Linking, View } from 'react-native';
import { Divider } from 'react-native-elements';
import { useNavigation } from '@react-navigation/native';
import type { StackNavigationProp } from '@react-navigation/stack';
import { Icon } from '@/components/Icon';
import { Text } from '@/components/Text';
import { PressableNeolexon } from '@/components/PressableNeolexon';
import { SubMenuItem as SubMenuItemType } from '@/components/ui/therapist/CollapsibleSidebar';
import { TherapistStackParamList } from '@/navigations/TherapistStack';
import { useOnHover } from '@/hooks/useOnHover';

import { styles } from './styles';
import colors from '@/config/colors';

export const SubMenuItem = ({
  setExpandedSubMenu,
  subItem,
}: {
  setExpandedSubMenu: (submenu: SubMenuItemType[] | null) => void;
  subItem: SubMenuItemType;
}) => {
  const { icon, label, screen, url } = subItem;
  const { isHovered, handleHoverIn, handleHoverOut } = useOnHover();
  const { navigate } =
    useNavigation<StackNavigationProp<TherapistStackParamList>>();
  return (
    <>
      <PressableNeolexon
        onPress={() => {
          url ? Linking.openURL(url) : navigate(screen as any);
          setExpandedSubMenu(null);
        }}
        onHoverIn={() => handleHoverIn()}
        onHoverOut={() => handleHoverOut()}
      >
        <View
          style={[
            styles.menuItemContainer,
            isHovered && styles.isSelected,
            { display: 'flex', justifyContent: 'space-between' },
          ]}
        >
          <Text style={styles.subMenuItem}>{label}</Text>
          {icon && <Icon name={icon} size={15} />}
        </View>
      </PressableNeolexon>
      <Divider color={colors.lightGrey} width={2} />
    </>
  );
};
